export default "__VITE_ASSET__OTXs2bOR__"